import { faMobileScreen } from '@fortawesome/pro-solid-svg-icons'
import AppHandoff from './AppHandoff'
import { UpgradeHandoffOutcome, isUpgradeHandoffOutcome, upgradeAppUrl, upgradeHandoffToken } from './upgradeHandoffModel'

export type Props = {
  outcome: string
  scheme: string
  sessionId: string
}

const INVALID_LINK_MESSAGE = 'This link is not valid. Please return to the SynkedUP app to check your plan.'

const PROMPTS: Record<UpgradeHandoffOutcome, string> = {
  success: 'Your upgrade is on its way. Opening the SynkedUP app so you can pick up where you left off. If it does not open on its own, tap the button below.',
  cancel: 'No changes were made to your plan. Opening the SynkedUP app so you can pick up where you left off. If it does not open on its own, tap the button below.',
  portal: 'Any changes to your subscription are saved. Opening the SynkedUP app so you can pick up where you left off. If it does not open on its own, tap the button below.'
}

const ALREADY_OPENED_PROMPT = 'This link has already opened the SynkedUP app on this device. You can close this tab. If you still need to get back to the app, tap the button below.'

const UpgradeHandoff = ({ outcome, scheme, sessionId }: Props) => <AppHandoff
  token={upgradeHandoffToken(outcome, sessionId)}
  appUrl={upgradeAppUrl(outcome, scheme, sessionId)}
  invalidLinkMessage={INVALID_LINK_MESSAGE}
  prompt={isUpgradeHandoffOutcome(outcome) ? PROMPTS[outcome] : ''}
  alreadyOpenedPrompt={ALREADY_OPENED_PROMPT}
  buttonLabel="Return to SynkedUP"
  icon={faMobileScreen}
/>

export default UpgradeHandoff
